<template>
  <template-card
    :template="template"
    :is_selected="is_selected"
    @select="$emit('select', template)"
  >
    <template #preview>
      <div class="lightbox-preview-container">
        <div class="template_lightbox_blur" :style="blur_style"></div>

        <div class="template_container" :style="container_style">
          <div class="header_bkg" :style="header_style">
            <img v-if="use_logo && image_url" :src="image_url" :style="image_style" alt="" />

            <div v-else class="template_preview-banner" :style="banner_style">
              {{ banner_text }}
            </div>
          </div>

          <v-icon
            class="close_icon"
            :class="{ close_icon_with_logo: use_logo }"
            :style="getStyleForComponent(template.template_overrides.close_icon)"
            :size="15"
          >
            mdi-close
          </v-icon>

          <div
            class="template_container_content"
            :style="getStyleForComponent(template.template_overrides.container_content)"
          >
            <div
              class="container_background"
              :style="getStyleForComponent(template.template_overrides.container_background)"
            ></div>

            <div class="preview-content">
              <div class="preview-line" :style="line1_style">{{ line1_text }}</div>

              <div class="preview-line" :style="line2_style">{{ line2_text }}</div>

              <div class="preview-line" :style="line3_style">{{ line3_text }}</div>

              <div class="form-container">
                <div class="mt-4">
                  <v-row align="start">
                    <v-col cols="12" md="6" class="pt-0">
                      <div
                        v-if="
                          template.template_overrides.first_name &&
                            template.template_overrides.first_name.field_mode !== 'hidden'
                        "
                        class="text-field-container"
                      >
                        <label :style="first_name_label_style" for="first-name-input">
                          First Name
                          <span
                            v-if="template.template_overrides.first_name.field_mode === 'required'"
                            class="required"
                          >
                            *
                          </span>
                        </label>
                        <input
                          id="first-name-input"
                          type="text"
                          :style="first_name_style"
                          aria-label="First Name"
                          class="input-field"
                          value=""
                          readonly
                        />
                      </div>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      class="pt-0"
                      v-if="
                        template.template_overrides.last_name &&
                          template.template_overrides.last_name.field_mode !== 'hidden'
                      "
                    >
                      <div class="text-field-container">
                        <label :style="last_name_label_style" for="last-name-input">
                          Last Name
                          <span
                            v-if="template.template_overrides.last_name.field_mode === 'required'"
                            class="required"
                          >
                            *
                          </span>
                        </label>
                        <input
                          id="last-name-input"
                          type="text"
                          :style="last_name_style"
                          aria-label="Last Name"
                          class="input-field"
                          value=""
                          readonly
                        />
                      </div>
                    </v-col>
                  </v-row>

                  <v-row align="start">
                    <v-col
                      cols="12"
                      md="6"
                      class="pt-0"
                      v-if="
                        template.template_overrides.birthday &&
                          template.template_overrides.birthday.field_mode !== 'hidden'
                      "
                    >
                      <div class="text-field-container">
                        <label :style="birthday_label_style" for="birthday-input">
                          Birthday
                          <span
                            v-if="template.template_overrides.birthday.field_mode === 'required'"
                            class="required"
                          >
                            *
                          </span>
                        </label>
                        <input
                          id="birthday-input"
                          type="text"
                          :style="birthday_style"
                          aria-label="Birthday"
                          class="input-field"
                          value=""
                          readonly
                        />
                        <p class="ma-0 text-left" :style="birthday_hint_style">MM/DD/YYYY</p>
                      </div>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      class="pt-0"
                      v-if="
                        template.template_overrides.phone_number &&
                          template.template_overrides.phone_number.field_mode !== 'hidden'
                      "
                    >
                      <div class="text-field-container">
                        <label :style="phone_number_label_style" for="phone-input">
                          Phone Number
                          <span
                            v-if="
                              template.template_overrides.phone_number.field_mode === 'required'
                            "
                            class="required"
                          >
                            *
                          </span>
                        </label>
                        <input
                          id="phone-input"
                          type="text"
                          :style="phone_number_style"
                          aria-label="Phone Number"
                          class="input-field"
                          value=""
                          readonly
                        />
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col v-if="template.template_overrides.email_address" class="pt-0">
                      <div class="text-field-container">
                        <label :style="email_address_label_style" for="email-input">
                          Email Address
                          <span
                            v-if="
                              template.template_overrides.email_address.field_mode === 'required'
                            "
                            class="required"
                          >
                            *
                          </span>
                        </label>
                        <input
                          id="email-input"
                          type="email"
                          :style="email_address_style"
                          aria-label="Email Address"
                          class="input-field"
                          value=""
                          readonly
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <div
                  v-if="show_agreement"
                  :style="getStyleForComponent(template.template_overrides.agreement)"
                  class="agreement"
                >
                  <span>
                    {{ parsed_agreement_text }}
                  </span>
                </div>

                <v-btn class="preview-button" tabindex="-1" :style="button_style">
                  <span :style="button_text_style">{{ button_text }}</span>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </template-card>
</template>

<script>
import _ from 'lodash';
import { template } from 'lodash';
import TemplateCard from '@/components/shared/cards/template-card.vue';

export default {
  components: {
    TemplateCard,
  },

  props: {
    template: {
      type: Object,
      required: true,
    },

    is_selected: {
      type: Boolean,
      default: false,
    },

    theme: {
      type: Object,
      default: null,
    },

    lightbox_params: {
      type: Object,
      default: null,
    },

    show_agreement: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      viewport_width: window.innerWidth,
      mobile_breakpoint: 768,
    };
  },

  mounted() {
    window.addEventListener('resize', this.onResize, false);
    this.viewport_width = window.innerWidth;
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  computed: {
    is_mobile() {
      const breakpoint =
        this.applied_template?.template_overrides?.mobile_breakpoint || this.mobile_breakpoint;
      return this.viewport_width < breakpoint;
    },

    applied_template() {
      return this.applyThemeToTemplate(this.template, this.theme);
    },

    blur_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.background_blur);
    },

    container_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.container);
    },

    close_icon_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.close_icon);
    },

    first_name_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.first_name);
    },

    first_name_label_style() {
      return this.applied_template?.template_overrides?.first_name?.label_style || '';
    },

    last_name_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.last_name);
    },

    last_name_label_style() {
      return this.applied_template?.template_overrides?.last_name?.label_style || '';
    },

    birthday_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.birthday);
    },

    birthday_label_style() {
      return this.applied_template?.template_overrides?.birthday?.label_style || '';
    },

    birthday_hint_style() {
      return this.applied_template?.template_overrides?.birthday?.hint_style || '';
    },

    phone_number_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.phone_number);
    },

    phone_number_label_style() {
      return this.applied_template?.template_overrides?.phone_number?.label_style || '';
    },

    email_address_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.email_address);
    },

    email_address_label_style() {
      return this.applied_template?.template_overrides?.email_address?.label_style || '';
    },

    header_style() {
      return this.getStyleForComponent(
        this.applied_template?.template_overrides?.header_background
      );
    },

    image_url() {
      return (
        this.applied_template?.template_overrides?.logo_image?.url ??
        this.lightbox_params?.logo_image?.url ??
        null
      );
    },

    image_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.logo_image);
    },

    banner_text() {
      return (
        this.applied_template?.template_overrides?.banner_text?.text ??
        this.lightbox_params?.banner_text?.text ??
        ''
      );
    },

    banner_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.banner_text);
    },

    line1_text() {
      return (
        this.applied_template?.template_overrides?.line_1?.text ??
        this.lightbox_params?.line_1?.text ??
        ''
      );
    },

    line1_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.line_1);
    },

    line2_text() {
      return (
        this.applied_template?.template_overrides?.line_2?.text ??
        this.lightbox_params?.line_2?.text ??
        ''
      );
    },

    line2_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.line_2);
    },

    line3_text() {
      return (
        this.applied_template?.template_overrides?.line_3?.text ??
        this.lightbox_params?.line_3?.text ??
        ''
      );
    },

    line3_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.line_3);
    },

    button_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.send_button);
    },

    button_text() {
      return (
        this.applied_template?.template_overrides?.send_button_text?.text ||
        this.lightbox_params?.send_button_text?.text ||
        'Subscribe'
      );
    },

    button_text_style() {
      return this.getStyleForComponent(this.applied_template?.template_overrides?.send_button_text);
    },

    parsed_agreement_text() {
      return (
        this.lightbox_params?.agreement.text
          ?.replace(
            '{organization-label}',
            this.$rc.$state.getOrganizationLabel() || 'Your Organization'
          )
          .replace('[Terms]({organization-tcr-terms-url})', 'terms')
          .replace('[Privacy Policy]({organization-tcr-privacy-policy-url})', 'privacy policy') ||
        this.agreement_text
      );
    },

    use_logo() {
      return (
        this.applied_template?.template_overrides?.use_logo ||
        this.lightbox_params?.use_logo ||
        false
      );
    },
  },

  methods: {
    onResize() {
      this.viewport_width = window.innerWidth;
    },

    getStyleForComponent(componentParams) {
      if (!componentParams) return '';

      if (this.is_mobile && componentParams.mobile_styles) {
        return componentParams.mobile_styles;
      }

      return componentParams.style || '';
    },

    applyThemeToTemplate(template, theme_selections) {
      if (!theme_selections || !template) return template;

      const template_copy = _.cloneDeep(template);

      const primary_color = theme_selections.colors.primary?.value || '#007bff';
      const font_family = theme_selections.font_family || 'Arial, sans-serif';

      const _applyThemeStyling = obj => {
        if (typeof obj === 'string') {
          return obj
            .replace(/{primary_color}/g, primary_color)
            .replace(/font-family:\s*[^;]+/g, `font-family: ${font_family}`);
        } else if (typeof obj === 'object' && obj !== null) {
          const result = {};
          for (const [key, value] of Object.entries(obj)) {
            result[key] = _applyThemeStyling(value);
          }
          return result;
        }
        return obj;
      };

      template_copy.template_overrides = _applyThemeStyling(template_copy.template_overrides);

      return template_copy;
    },
  },
};
</script>

<style lang="scss" scoped>
.lightbox-preview-container {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 2rem 1.5rem;
  background: #f5f5f5;
  width: 100%;
  height: 100%;

  background-image: url('https://files.redchirp.com/644eb29a-b21a-49fc-892a-32dbaad6531a.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  & * {
    pointer-events: none !important;
  }
}

:deep(.template-preview-area) {
  align-self: unset;
}

.template_container {
  position: relative;
  background: white;
  border-radius: 0.5rem;
  overflow: hidden;
  height: min-content;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 100%;
  z-index: 8;

  .close_icon {
    position: absolute;
    top: 8px;
    right: 8px;
    min-width: 30px;
    min-height: 30px;
  }

  .close_icon_with_logo {
    top: 5px;
    right: 5px;
    z-index: 10;
  }
}

.preview-content {
  padding: 8px 12px;
  position: relative;
  z-index: 2;
}

.preview-button {
  background: var(--v-primary-base);
  border-radius: 0.125rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.template_lightbox_blur {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 7;
}

.agreement {
  font-size: 12px;
  text-align: justify;
  margin-top: 25px;
  color: rgba(0, 0, 0, 0.5);
}

/* 
    Below styles were taken from m-text-field.vue in widget app.
    There are limitations related to vue 2 vs 3 that prevent us from using the component directly.
*/

.header_bkg {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    object-fit: cover;
    object-position: center top;
    width: 100%;
    height: 100%;
  }
}

.form-container {
  margin-left: 40px;
  margin-right: 40px;
  margin-top: 5px;
  font-size: 16px;
  line-height: 1.4;
}

@media only screen and (max-width: 767px) {
  .form-container {
    margin: 15px 10px 0;
  }

  .name-fields-container {
    flex-direction: column;
    gap: 0;
  }

  .birthday-phone-fields-container {
    flex-direction: column;
    gap: 0;
  }
}

@media only screen and (max-width: 480px) {
  .form-container {
    margin-left: 5px;
    margin-right: 5px;
  }
}

input,
textarea {
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  font-size: 16px !important;
  padding: 0px 10px 12px 0px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
  background-color: white;
  border-radius: 0px;
  min-height: 44px;
  line-height: 1;
  /* Minimum touch target size */
  -webkit-text-size-adjust: 100%;
  /* Prevent text scaling */
  text-size-adjust: 100%;
  /* Prevent text scaling */
}

@media only screen and (max-width: 767px) {
  input,
  textarea {
    padding: 6px 0px 12px 0px;
    margin-bottom: 3px;
  }

  /* Hide animated bar on mobile to prevent double underlines */
  .bar:before,
  .bar:after {
    display: none;
  }
}

label {
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  color: #999;
  font-size: 14px;
  font-weight: 300;
  position: absolute;
  pointer-events: none;
  left: 0px;
  top: 14px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.text-field-container {
  position: relative;
  margin-top: 12px;
}

@media only screen and (max-width: 767px) {
  .text-field-container {
    margin-top: 8px;
    margin-bottom: 8px;
    padding-bottom: 5px;
  }
}

.container_background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
}

.required {
  color: inherit;
}
</style>
